import CalendarGifNew from "../../assets/images/calendar-new.gif";

const CommonLeaveOverview = ({ leaveData }) => {
  return (
    <>
      <div className="leaveOverview">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="total-leaves">
                <div className="heading">
                  <span>Total Leaves</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="taken-leaves">
                <div className="heading">
                  <span>Total Taken Leaves</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="balance-leaves">
                <div className="heading">
                  <span>Total Balance Leaves</span>
                </div>
              </div>
            </div>
          </div>
          <div className="row leave-overview scroll">
            <div className="col-lg-4">
              <div className="leaveOverview-flex">
                <div className="leave-types">
                  <div className="heading active">
                    <span>Leaves Type</span>
                  </div>
                  <div className="list">
                    <div className="item">
                      <span>Paid Leaves</span>
                    </div>
                    <div className="item">
                      <span>LOP</span>
                    </div>
                    <div className="item">
                      <span>Goodwill</span>
                    </div>
                  </div>
                </div>

                <div className="leave-types total">
                  <div className="list">
                    <div className="item">
                      <span>Total: {leaveData.yearlyAllocatedleaves}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="leaveOverview-flex">
                <div className="leave-types">
                  <div className="heading">
                    <span>&nbsp;</span>
                  </div>
                  <div className="list">
                    <div className="item">
                      <span>{leaveData.paidleave}</span>
                    </div>

                    <div className="item">
                      <span>{leaveData.lop}</span>
                    </div>
                    <div className="item">
                      <span>{leaveData.goodwill}</span>
                    </div>
                  </div>
                </div>

                <div className="leave-types total">
                  <div className="list">
                    <div className="item">
                      <span>Total Taken: {leaveData.totalTakenLeaves}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="leave-flex">
                <div className="leaves-info2">
                  <div className="flex">
                    <span>Total yearly leaves:</span>
                    <span className="count">
                      {leaveData.yealrlyBalanceLeaves}
                    </span>
                  </div>
                  <div className="flex">
                    <span>Total Quarterly leaves:</span>
                    <span className="count">{leaveData.queterBalance}</span>
                  </div>
                  {/* <div className="flex">
                      <span>Total Monthly leaves:</span>
                      <span className="count">1.5</span>
                    </div> */}
                </div>
                <img src={CalendarGifNew} width={150} alt="" />
                <div className="leaves-bal">
                  <div className="leaves-bal1">
                    <div className="flex">
                      <span>Total Loss of pay:</span>
                      <span className="count">{leaveData.lop}</span>
                    </div>
                    <div className="flex">
                      <span>Total Earned Leaves taken:</span>
                      <span className="count">{leaveData.paidleave}</span>
                    </div>
                  </div>
                  <div className="leaves-bal2">
                    <div className="flex">
                      <span>Total Taken Leaves:</span>
                      <span className="count">
                        {leaveData.totalTakenLeaves}
                      </span>
                    </div>
                    <div className="flex">
                      <span>Total Balance Leaves:</span>
                      <span className="count">
                        {leaveData.yealrlyBalanceLeaves}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommonLeaveOverview;
